export interface VersionInfo {
  version: string;
  releaseDate: string;
  releaseType: 'major' | 'minor' | 'patch' | 'hotfix';
  changelog: {
    new?: string[];
    improved?: string[];
    fixed?: string[];
  };
}

export const currentVersion: VersionInfo = {
  version: "1.0.0",
  releaseDate: "2025-01-17",
  releaseType: "major",
  changelog: {
    new: [
      "Admin Portal Version Information Display",
      "Enhanced Mobile Practitioner Detail View",
      "Database Migration for Email System Optimization"
    ],
    improved: [
      "Better mobile responsiveness on practitioner detail pages",
      "Optimized admin login page layout",
      "Enhanced user experience in booking flows"
    ],
    fixed: [
      "Fixed navbar overlay issue on admin login page",
      "Resolved narrow display issue on mobile practitioner details",
      "Removed problematic database triggers causing email conflicts"
    ]
  }
};

export const versionHistory: VersionInfo[] = [
  currentVersion
];

export const getVersionBadgeColor = (type: VersionInfo['releaseType']) => {
  switch (type) {
    case 'major':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'minor':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'patch':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'hotfix':
      return 'bg-orange-100 text-orange-800 border-orange-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
};